import React from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function LegalShell({ eyebrow, title, updated, children }) {
  return (
    <div className="bg-[color:var(--f2-bg)] min-h-screen text-white flex flex-col">
      <Nav />
      <main className="flex-1">
        <div className="relative overflow-hidden">
          <div className="absolute inset-0 grid-lines opacity-30 pointer-events-none" />
          <div className="max-w-[900px] mx-auto px-6 md:px-10 py-20 relative z-10">
            <div className="label-xs mb-2">{eyebrow}</div>
            <h1 className="font-display uppercase tracking-tighter font-black text-4xl md:text-6xl">
              {title}
            </h1>
            <div className="label-xs mt-4 text-[color:var(--f2-muted)]">
              Last updated: {updated} · Governed by the laws of India · Exclusive jurisdiction: Chennai, Tamil Nadu
            </div>
            <div className="mt-10 space-y-8 text-sm leading-relaxed text-[color:var(--f2-muted)]">
              {children}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export function Section({ n, title, children }) {
  return (
    <section>
      <div className="flex items-baseline gap-3 mb-3">
        <span className="label-xs saffron">§ {n}</span>
        <h2 className="font-display font-bold text-xl md:text-2xl text-white uppercase tracking-tight">
          {title}
        </h2>
      </div>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
